import styles from "./index.module.scss";
import {Dropdown, Select} from "antd";
import {ArrowDownIcon, CheckedIcon, ClearIcon, NoCheckedIcon} from "@/config/config";
import {CheckOutlined, SmileOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";


const SelectComp = ({opts = [], value, placeholder = "Select", onChange = () => {} }) =>{
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([...opts]);

  const convertOpts = (options) =>{
    const opts = options.map(item=>{
      return {
        key: item.key,
        label:<span className={"font-400 text-[14px]"}>{item.label}</span>,
        icon: <div className={`${styles.check_icon} ${ item.checked ? styles.checked_icon : "" }`}></div>,
      };
    });
    return opts;
  };

  const clearAll = (e) =>{
    e.stopPropagation();
    options.forEach(item=>{
      item.checked = false;
    });
    setOptions(options.slice());
    setOpen(false);
    onChange([]);
  };

  const render = () =>{
    const checkedList = options.filter(item=>item.checked);
    if (checkedList.length <= 0) {
      return <div key={"Select_Dropdown_Wrap_text_1"} className={"flex !text-[#A7A7A7] w-full justify-between items-center"}>
        {placeholder} <img key={"Select_Dropdown_Wrap_text_1_1"} className={styles.arrow_down} src={ArrowDownIcon}></img>
      </div>;
    }

    return <div key={"Select_Dropdown_Wrap_text_2"} className={"flex w-full justify-between items-center"}>
      <div key={"Select_Dropdown_Wrap_text_3"} className={"text_ellipsis max-w-[180px]"}>
        {checkedList.map(item => item.label).join(", ")}
      </div>
      <img key={"Select_Dropdown_Wrap_text_3"} onClick={clearAll} className={styles.clear_icon} src={ClearIcon} />
    </div>;
  };

  const onClick = ({key}) =>{
    options.forEach(item=>{
      if (item.key === Number(key)){
        item.checked = !item.checked;
      }
    });

    const ids = options.filter(item=>item.checked).map(item=>item.key);
    onChange?.(ids);
    setOptions(options.slice());
  };

  const handleOpenChange = (nextOpen, info) => {
    if (info.source === 'trigger' || nextOpen) {
      setOpen(nextOpen);
    }
  };

  useEffect(()=>{
    if (value.length <= 0){
      options.forEach(item=>{
        item.checked = false;
      });
      setOptions(options.slice());
      setOpen(false);
    }
  }, [value]);

  return (
    <Dropdown
      menu={{
        items:convertOpts(options),
        onClick:onClick
      }}
      trigger={["click"]}
      onOpenChange={handleOpenChange}
      open={open}
      key={"Select_Dropdown"}
    >
      <div key={"Select_Dropdown_Wrap"} className={`${styles.select_wrap} ${(open || !(options.filter(item=>item.checked).length <= 0)) && styles.border}`}>
        <div key={"Select_Dropdown_Wrap_Child"} className={"px-4 w-full"}>
          {render()}
        </div>
      </div>
    </Dropdown>
  );
};

export default SelectComp;
